// extracted by mini-css-extract-plugin
export default {"actionBar":"app-react-components-StickyFooter-StickyFooter-module__actionBar"};